import { useState } from 'react';
import Rules from '../pages/Rules';
import Thresholds from '../pages/Thresholds';

export default function FilterTabs() {
  const [activeTab, setActiveTab] = useState('rules');

  return (
    <div className="flex flex-col h-full">
      {/* Tab Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="flex">
          <button
            onClick={() => setActiveTab('rules')}
            className={`flex-1 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'rules'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            Rules
          </button>
          <button
            onClick={() => setActiveTab('thresholds')}
            className={`flex-1 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'thresholds'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            Thresholds
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">
        <div className="p-4">
          {activeTab === 'rules' ? <Rules /> : <Thresholds />}
        </div>
      </div>
    </div>
  );
}